import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UPBindConfigPlugin = function (_NebulaModuleBase) {
    _inherits(UPBindConfigPlugin, _NebulaModuleBase);

    function UPBindConfigPlugin() {
        _classCallCheck(this, UPBindConfigPlugin);

        var _this = _possibleConstructorReturn(this, (UPBindConfigPlugin.__proto__ || Object.getPrototypeOf(UPBindConfigPlugin)).apply(this, arguments));

        _this.bindDiscoverDeviceWithWiFiTime = 0;
        _this.bindDeviceWithoutWiFiTime = 0;
        _this.updateRouterInfoTime = 0;
        return _this;
    }

    _createClass(UPBindConfigPlugin, [{
        key: 'bindDiscoverDeviceWithWiFi',
        value: function bindDiscoverDeviceWithWiFi(wiFiInfo, discoverDevInfo, nfcInfoStr, timeoutInterval, listener) {
            var event = 'onBindDiscoverDeviceWithWiFi' + this.bindDiscoverDeviceWithWiFiTime;
            this.bindDiscoverDeviceWithWiFiTime++;
            var params = {
                eventName: event,
                wiFiInfo: wiFiInfo,
                discoverDevInfo: discoverDevInfo,
                nfcInfoStr: nfcInfoStr,
                timeoutInterval: timeoutInterval
            };
            return this.generatePromiseByAttachListenerWithParams(event, listener, 'BindDiscoverDeviceWithWiFiForBindConfigPlugin', params);
        }
    }, {
        key: 'bindDeviceWithoutWiFi',
        value: function bindDeviceWithoutWiFi(deviceId, listener) {
            var event = 'onBindDeviceWithoutWiFi' + this.bindDeviceWithoutWiFiTime;
            this.bindDeviceWithoutWiFiTime++;
            var params = {
                eventName: event,
                deviceId: deviceId
            };
            return this.generatePromiseByAttachListenerWithParams(event, listener, 'BindDeviceWithoutWiFiForBindConfigPlugin', params);
        }
    }, {
        key: 'updateRouterInfo',
        value: function updateRouterInfo(wiFiInfo, deviceId, listener) {
            var event = 'onUpdateRouterInfo' + this.updateRouterInfoTime;
            this.updateRouterInfoTime++;
            var params = {
                eventName: event,
                wiFiInfo: wiFiInfo,
                deviceId: deviceId
            };
            return this.generatePromiseByAttachListenerWithParams(event, listener, 'UpdateRouterInfoForBindConfigPlugin', params);
        }
    }]);

    return UPBindConfigPlugin;
}(NebulaModuleBase);